<script>

export default {
  name: 'PriceTag',

  props: {
    priceSlot: {
      type: Object,
      required: true
    },

    footnoteNumber: {
      type: Number
    }
  },

  computed: {
    price() {
      return this.priceSlot.to_pay_per_unit || this.priceSlot.to_pay_per_hour
    },

    formattedPrice () {
      return (this.price.cents / 100.0).toFixed(2).replace('.', ',')
    },

    translatedSlotName () {
      if (this.$te(`pricing.slots.${this.priceSlot.name}`)) {
        return this.$t(`pricing.slots.${this.priceSlot.name}`)
      }

      return this.priceSlot.title
    },

    translatedUnitName() {
      if(this.priceSlot.name === 'period') return this.$t(`pricing.period`)
      if(this.priceSlot.to_pay_per_hour) return this.$t(`pricing.slots.hour`)
      return this.translatedSlotName
    },

    includedMileage () {
      return this.priceSlot.km_included > 0
    }
  }

}
</script>

<template>

  <div class="columns text-center slot">

    <h5>
      {{ translatedSlotName }}
      <sup v-if="footnoteNumber">{{ footnoteNumber }}</sup>
    </h5>

    <div class="price text-color">
      {{ formattedPrice }}
      <span v-if="price.vat_status == 'net'" class="net-hint">*</span>
    </div>

    <div>
      {{ price.currency }} / {{ translatedUnitName }}
    </div>

    <div v-if="includedMileage">
      <div class="mileage-details small">
        {{ $t('pricing.km_included', {km: priceSlot.km_included}) }}
      </div>
    </div>

  </div>

</template>

<style lang="scss" scoped>
.columns {
  float: left !important;
}
h5 {
  font-size: rem-calc(22);
  margin-bottom: rem-calc(5);
}
.price {
  font-size: rem-calc(40);
  font-weight: bold;
  position: relative;
}

.net-hint {
  font-size: rem-calc(20);
  position: absolute;
  top: 0;
  margin-top: 8px;
  margin-left: 5px;
}

.slot {
  padding: 0 10px;
}

.small {
  margin-top: rem-calc(4);
  font-size: rem-calc(12);
}
</style>



// WEBPACK FOOTER //
// src/components/PriceTag.vue